import { combineReducers } from "redux";
import commonReducer from "./commonReducer";
import documentReducer from './documentReducer'

const rootReducer = combineReducers({
    commonReducer,
    documentReducer
  
   
});

export default rootReducer;
